import Template from './EventSummaryQuantityView.njk';
import Marionette from "backbone.marionette";

export const EventSummaryQuantityView = Marionette.View.extend({
  template: Template,
    modelEvents: {
        'change:max': 'onMaxChange',
        'change:open': 'onOpenChange',
        'change:quantity': 'onQuantityChange'
    },

    initialize(options) {
        this.settings = options.settings;
    },

    getAvailabilityClass() {
        const open = this.model.get("open");
        if (open === 0) {
            return "full";
        }

        const max = this.model.get('max');

        if (max) {
            let percentage = open / max * 100;

            if (percentage <= 25) {
                if (percentage <= 10 || open == 1) {
                    return "almost-full";
                }
                else {
                    return "half-full";
                }
            }
            else {
                return "available"
            }
        }
        else {
            if (open > 2) {
                return "available";
            }
            else {
                return open == 2 ? "half-full" : "almost-full";
            }
        }
    },

    templateContext() {
        var slots;
        if (this.settings.events.availability == "available") {
            slots = this.model.get("open") < 99998 ? this.model.get("open") : '&infin;';
        }
        else {
            slots = this.model.get("quantity") ? this.model.get("quantity").reserved : 0;
        }

        return {
            openSlots: slots,
            availability: this.getAvailabilityClass(),
            availabilityText: this.settings.events.availability == "available" ? "Available" : "Reserved"
        }
    },

    onOpenChange() {
        if (this.settings.events.availability == "available") {
            this.render();
        }
    },

    onMaxChange() {
        this.render();
    },

    onQuantityChange() {
        if (this.settings.events.availability != "available") {
            this.render();
        }
    }
});



// WEBPACK FOOTER //
// ./src/js/view/components/EventSummary/EventSummaryQuantityView.js